export const FINAL_ID = -1
export const HEMIFINAL_ID = -2
export const FOR_SEVENTH_PLACE = -3
export const FOR_FIFTH_PLACE = -4
export const THIRD_TOP_GRID_ID = 2
export const SECOND_TOP_GRID_ID = 1
export const FIRST_TOP_GRID_ID = 0